module.exports = __webpack_public_path__ + "img/9788946040489.7c4dd046.jpg";